import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/pages/MainPage'
import CatalogSectionPage from '@/pages/CatalogSectionPage'
import CatalogCategoryPage from '@/pages/CatalogCategoryPage'
import CatalogJewelPage from '@/pages/CatalogJewelPage'
import RepairPage from '@/pages/RepairPage'
import AboutPage from '@/pages/AboutPage'
import AboutManufacturingPage from '@/pages/AboutManufacturingPage'
import AboutTeamPage from '@/pages/AboutTeamPage'
import ContactsPage from '@/pages/ContactsPage'
import SiteMapPage from '@/pages/SiteMapPage'
import ToJewelersPage from '@/pages/ToJewelersPage'
import RingsCalculatorPage from '@/pages/RingsCalculatorPage'
import ChainsCalculatorPage from '@/pages/ChainsCalculatorPage'
import Page404 from '@/pages/Page404'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/:section(catalog|catalogsilver|exclusive)',
      name: 'CatalogSectionPage',
      component: CatalogSectionPage
    },
    {
      path: '/:section(catalog|catalogsilver|exclusive)/:category/1',
      redirect: '/:section(catalog|catalogsilver|exclusive)/:category'
    },
    {
      path: '/:section(catalog|catalogsilver|exclusive)/:category/:page?',
      name: 'CatalogCategoryPage',
      meta: {
        nonBreadcrumbParts: [':page'],
        scrollPosition: { x: 0, y: 0 }
      },
      component: CatalogCategoryPage
    },
    {
      path: '/:section(catalog|catalogsilver|exclusive)/:category/jewel/:jewel',
      name: 'CatalogJewelPage',
      meta: { nonBreadcrumbParts: ['jewel'] },
      component: CatalogJewelPage
    },
    {
      path: '/repair',
      name: 'RepairPage',
      component: RepairPage
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage
    },
    {
      path: '/about/manufacturing',
      name: 'AboutManufacturingPage',
      component: AboutManufacturingPage
    },
    {
      path: '/about/team',
      name: 'AboutTeamPage',
      component: AboutTeamPage
    },
    {
      path: '/tojewelers',
      name: 'ToJewelersPage',
      component: ToJewelersPage
    },
    {
      path: '/tojewelers/ringcalculator',
      name: 'RingsCalculatorPage',
      component: RingsCalculatorPage
    },
    {
      path: '/tojewelers/chaincalculator',
      name: 'ChainsCalculatorPage',
      component: ChainsCalculatorPage
    },
    {
      path: '/contacts',
      name: 'ContactsPage',
      component: ContactsPage
    },
    {
      path: '/sitemap',
      name: 'SiteMapPage',
      component: SiteMapPage
    },
    {
      path: '/404',
      name: 'Page404',
      component: Page404
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.path !== from.path) {
      if (savedPosition) {
        to.meta.scrollPosition = savedPosition
        return savedPosition
      } else {
        if (to.meta.showMore) {
          delete to.meta.showMore
        } else {
          from.meta.scrollPosition = { x: 0, y: 0 }
        }
        return { x: 0, y: 0 }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js